/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Pagination, RequestParams } from '~core/models/core.models';
import { CreateProductParams, Product } from '~core/models/core.models';
import { PRODUCT_URL } from '../constants/api.constants';

@Injectable()
export class ProductService {
  private _httpClient = inject(HttpClient);

  read(userId: string): Observable<Product> {
    return this._httpClient.get<Product>(`${PRODUCT_URL}/${userId}`);
  }

  list(
    params?: RequestParams & {
      [key: string]: any;
    }
  ): Observable<Pagination<Product>> {
    return this._httpClient.get<Pagination<Product>>(PRODUCT_URL, {
      params: {
        ...params,
        sort: params?.sort || 'createdAt',
        desc: params?.desc || 'createdAt'
      } as Record<string, any>
    });
  }

  create(data: CreateProductParams): Observable<Product> {
    return this._httpClient.post<Product>(PRODUCT_URL, {
      ...data,
      useStateFormViolationHandler: true
    });
  }

  update(id: string, data: Partial<CreateProductParams>): Observable<Product> {
    return this._httpClient.patch<Product>(`${PRODUCT_URL}/${id}`, {
      ...data,
      useStateFormViolationHandler: true
    });
  }

  import(file: File, appName: string): Observable<void> {
    const formData = new FormData();
    formData.append('file', file);

    const endpointMap: Record<string, string> = {
      products: 'import',
      saleFormat: 'import/sale-formats'
    } as const;
    const endpoint = endpointMap[appName];

    return this._httpClient.post<void>(`${PRODUCT_URL}/${endpoint}`, formData);
  }

  delete(productId: string): Observable<unknown> {
    return this._httpClient.delete<unknown>(`${PRODUCT_URL}/${productId}`);
  }

  deleteMultiple(ids: string[]): Observable<unknown> {
    return this._httpClient.post<unknown>(`${PRODUCT_URL}/delete`, { ids });
  }
}
